if (!customElements.get('rr-product-details-line')) {
  customElements.define('rr-product-details-line', class extends HTMLElement {
    connectedCallback() {
      const gallery = this.closest('media-gallery');
      const viewer = this.parentElement;
      const specs = viewer.querySelector('[data-rr-product-specs]');
      const nav = viewer.querySelector('[data-rr-gallery-nav]');
      const mobile = window.matchMedia('(max-width: 749px)');
      this.align = () => {
        const image = gallery?.querySelector('.product__media-item.is-active .product__media') || gallery?.querySelector('.product__modal-opener--image .product__media');
        if (!image) return;
        const imageRect = image.getBoundingClientRect();
        const rowRect = this.getBoundingClientRect();
        let imageLeft = imageRect.left;
        if (this.mediaList) {
          const item = image.closest('.product__media-item');
          const firstItem = this.mediaList.querySelector('.product__media-item');
          imageLeft += this.mediaList.scrollLeft - (item.offsetLeft - firstItem.offsetLeft);
        }
        const currentMargin = parseFloat(getComputedStyle(this).marginLeft) || 0;
        this.style.marginLeft = `${currentMargin + imageLeft - rowRect.left}px`;
        this.style.width = `${imageRect.width}px`;
        if (specs) {
          const margin = parseFloat(getComputedStyle(specs).marginLeft) || 0;
          specs.style.marginLeft = `${margin + imageLeft - specs.getBoundingClientRect().left}px`;
          specs.style.width = `${imageRect.width}px`;
        }
        if (nav) {
          const parentRect = viewer.getBoundingClientRect();
          nav.style.left = `${imageLeft - parentRect.left}px`;
          nav.style.width = `${imageRect.width}px`;
          nav.style.top = `${imageRect.top - parentRect.top + imageRect.height / 2}px`;
          const items = Array.from(this.mediaList?.children || []);
          nav.hidden = items.length < 2;
          const previous = nav.querySelector('[data-rr-gallery-direction="previous"]');
          const next = nav.querySelector('[data-rr-gallery-direction="next"]');
          if (mobile.matches) {
            const scroll = this.mediaList.scrollLeft;
            previous.disabled = scroll <= 1;
            next.disabled = scroll + this.mediaList.clientWidth >= this.mediaList.scrollWidth - 1;
          } else {
            const current = Math.max(0, items.findIndex(item => item.classList.contains('is-active')));
            previous.disabled = current === 0;
            next.disabled = current >= items.length - 1;
          }
          previous.hidden = previous.disabled;
          next.hidden = next.disabled;
        }
      };
      this.resizeObserver = new ResizeObserver(this.align);
      if (gallery) {
        this.resizeObserver.observe(gallery);
        gallery.querySelectorAll('.product__media').forEach(media => this.resizeObserver.observe(media));
      }
      this.mediaObserver = new MutationObserver(this.align);
      if (gallery) this.mediaObserver.observe(gallery, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
      this.mediaList = gallery?.querySelector('.product__media-list');
      this.onScroll = () => {
        cancelAnimationFrame(this.alignFrame);
        this.alignFrame = requestAnimationFrame(() => {
          if (!mobile.matches && this.mediaList) {
            const items = Array.from(this.mediaList.children);
            const closest = items.reduce((best, item) => Math.abs(item.offsetLeft - this.mediaList.scrollLeft) < Math.abs(best.offsetLeft - this.mediaList.scrollLeft) ? item : best, items[0]);
            if (closest) items.forEach(item => item.classList.toggle('is-active', item === closest));
          }
          this.align();
        });
      };
      this.mediaList?.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onNavigate = event => {
        const button = event.target.closest('[data-rr-gallery-direction]');
        if (!button || !nav?.contains(button) || button.disabled) return;
        event.preventDefault();
        if (mobile.matches) {
          viewer.querySelector(`:scope > .slider-buttons button[name="${button.dataset.rrGalleryDirection}"]`)?.click();
        } else {
          const items = Array.from(this.mediaList?.children || []);
          const current = Math.max(0, items.findIndex(item => item.classList.contains('is-active')));
          const direction = button.dataset.rrGalleryDirection === 'next' ? 1 : -1;
          const next = items[current + direction];
          if (next && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(next.dataset.mediaId, false);
        }
        this.onScroll();
      };
      nav?.addEventListener('click', this.onNavigate);
      this.nav = nav;
      this.align();
      this.onClick = event => {
        if (!event.target.closest('[data-rr-product-zoom]')) return;
        const product = this.closest('product-info');
        const activeImage = product.querySelector('.product__media-item.is-active .product__modal-opener--image .product__media-toggle');
        const firstImage = product.querySelector('.product__modal-opener--image .product__media-toggle');
        (activeImage || firstImage)?.click();
      };
      this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      this.nav?.removeEventListener('click', this.onNavigate);
      this.resizeObserver?.disconnect();
      this.mediaObserver?.disconnect();
      this.mediaList?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.removeEventListener('click', this.onClick);
      cancelAnimationFrame(this.alignFrame);
    }
  });
}



